import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const cafeCollections = [
  {
    title: 'Compact Cafe Solutions',
    description: 'Space-efficient timber furniture perfect for small cafes and coffee shops.',
    image: 'https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/tables',
  },
  {
    title: 'Outdoor Cafe Collection',
    description: 'Weather-resistant wooden furniture for patios, terraces, and outdoor seating areas.',
    image: 'https://images.pexels.com/photos/1307698/pexels-photo-1307698.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/outdoor',
  },
  {
    title: 'Artisan Coffee House',
    description: 'Handcrafted wood tables and seating for specialty coffee establishments.',
    image: 'https://images.pexels.com/photos/1833399/pexels-photo-1833399.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/seating',
  },
  {
    title: 'Modern Bistro Furniture',
    description: 'Contemporary timber designs for casual dining and bistro environments.',
    image: 'https://images.pexels.com/photos/1579253/pexels-photo-1579253.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/tables',
  },
  {
    title: 'Cafe Lounge Seating',
    description: 'Comfortable wood-framed chairs and sofas for relaxed cafe lounge areas.',
    image: 'https://images.pexels.com/photos/2253643/pexels-photo-2253643.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/chairs',
  },
  {
    title: 'Quick Service Essentials',
    description: 'Durable wooden furniture designed for high-traffic quick-service cafes.',
    image: 'https://images.pexels.com/photos/1833320/pexels-photo-1833320.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/cafe/all',
  },
];

export const barCollections = [
  {
    title: 'Classic Pub Collection',
    description: 'Handcrafted solid wood bar furniture with traditional charm for authentic pub experiences.',
    image: 'https://images.pexels.com/photos/1267696/pexels-photo-1267696.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
  {
    title: 'Contemporary Bar Series',
    description: 'Sleek timber designs with modern finishes for upscale cocktail lounges and bars.',
    image: 'https://images.pexels.com/photos/274192/pexels-photo-274192.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
  {
    title: 'Industrial Timber Collection',
    description: 'Reclaimed wood and metal accents for urban breweries and taprooms.',
    image: 'https://images.pexels.com/photos/2291599/pexels-photo-2291599.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
  {
    title: 'Premium Lounge Seating',
    description: 'Luxurious wood-framed seating with leather upholstery for high-end establishments.',
    image: 'https://images.pexels.com/photos/2290070/pexels-photo-2290070.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
  {
    title: 'Rooftop Bar Essentials',
    description: 'Weather-resistant timber furniture designed for outdoor bar and terrace settings.',
    image: 'https://images.pexels.com/photos/1581384/pexels-photo-1581384.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
  {
    title: 'Wine Bar Elegance',
    description: 'Refined wooden furniture with sophisticated finishes for wine bars and tasting rooms.',
    image: 'https://images.pexels.com/photos/1850595/pexels-photo-1850595.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bar/all',
  },
];

export const livingRoomCollections = [
  {
    title: 'Modern Living Collection',
    description: 'Contemporary wooden furniture with sleek designs for stylish living rooms.',
    image: 'https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/sofas',
  },
  {
    title: 'Scandinavian Timber Series',
    description: 'Light wood furniture with clean lines inspired by Nordic craftsmanship.',
    image: 'https://images.pexels.com/photos/1457842/pexels-photo-1457842.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/armchairs',
  },
  {
    title: 'Comfort Living Range',
    description: 'Plush wood-framed sofas and chairs designed for ultimate relaxation.',
    image: 'https://images.pexels.com/photos/1350789/pexels-photo-1350789.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/sofas',
  },
  {
    title: 'Industrial Wood Collection',
    description: 'Reclaimed timber and metal accents for urban industrial living spaces.',
    image: 'https://images.pexels.com/photos/1866149/pexels-photo-1866149.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/coffee-tables',
  },
  {
    title: 'Classic Timber Elegance',
    description: 'Traditional wooden furniture with timeless craftsmanship and rich finishes.',
    image: 'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/all',
  },
  {
    title: 'Minimalist Wood Essentials',
    description: 'Functional solid wood furniture with clean, minimal aesthetic.',
    image: 'https://images.pexels.com/photos/1918291/pexels-photo-1918291.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/livingroom/media-units',
  },
];

export const restaurantCollections = [
  {
    title: 'Fine Dining Collection',
    description: 'Elegant timber furniture with premium finishes for upscale restaurants.',
    image: 'https://images.pexels.com/photos/262978/pexels-photo-262978.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/fine-dining-chairs',
  },
  {
    title: 'Family Dining Series',
    description: 'Durable wooden tables and chairs designed for family-friendly restaurants.',
    image: 'https://images.pexels.com/photos/67468/pexels-photo-67468.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/dining-tables',
  },
  {
    title: 'Urban Eatery Furniture',
    description: 'Contemporary wood designs for modern restaurants and urban dining spaces.',
    image: 'https://images.pexels.com/photos/1307698/pexels-photo-1307698.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/dining-chairs',
  },
  {
    title: 'Traditional Steakhouse',
    description: 'Rich dark wood furniture with leather accents for classic steakhouses.',
    image: 'https://images.pexels.com/photos/2788792/pexels-photo-2788792.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/restaurant-tables',
  },
  {
    title: 'Alfresco Dining Range',
    description: 'Weather-treated timber furniture for outdoor restaurant terraces and patios.',
    image: 'https://images.pexels.com/photos/1449773/pexels-photo-1449773.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/outdoor-seating',
  },
  {
    title: 'Private Dining Suites',
    description: 'Bespoke wooden furniture for intimate private dining rooms and VIP areas.',
    image: 'https://images.pexels.com/photos/3201921/pexels-photo-3201921.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/restaurant/lounge-furniture',
  },
];

export const bedroomCollections = [
  {
    title: 'Tranquil Timber Bedroom',
    description: 'Solid wood bedroom furniture crafted for peaceful, restorative sleep.',
    image: 'https://images.pexels.com/photos/1743231/pexels-photo-1743231.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/beds',
  },
  {
    title: 'Heritage Wood Collection',
    description: 'Traditional timber bed frames and wardrobes built to last generations.',
    image: 'https://images.pexels.com/photos/271816/pexels-photo-271816.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/wardrobes',
  },
  {
    title: 'Contemporary Bedroom Suite',
    description: 'Sleek wooden furniture with clean lines for modern bedroom spaces.',
    image: 'https://images.pexels.com/photos/1648776/pexels-photo-1648776.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/all',
  },
  {
    title: 'Premium Timber Retreat',
    description: 'Luxurious solid wood bedroom sets with premium finishes and craftsmanship.',
    image: 'https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/beds',
  },
  {
    title: 'Nordic Wood Bedroom',
    description: 'Light timber furniture inspired by Scandinavian design principles.',
    image: 'https://images.pexels.com/photos/1454806/pexels-photo-1454806.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/nightstands',
  },
  {
    title: 'Industrial Loft Bedroom',
    description: 'Reclaimed wood and metal bedroom furniture for urban loft living.',
    image: 'https://images.pexels.com/photos/2029722/pexels-photo-2029722.jpeg?auto=compress&cs=tinysrgb&w=800&q=80',
    link: '/bedroom/dressers',
  },
];

const CollectionCard = ({ collection, imageHeight }) => {
  return (
    <div className="flex flex-col items-center text-center bg-white rounded-lg shadow-md p-0 w-[250px] sm:w-[280px] md:w-[300px] min-h-[380px] sm:min-h-[400px] md:min-h-[420px] transition-transform duration-200 ease-in-out flex-shrink-0 snap-center">
      <div className="w-full relative overflow-hidden bg-gray-100">
        <div className="aspect-[4/3] w-full">
          <img
            src={collection.image}
            alt={collection.title}
            className="absolute inset-0 w-full h-full object-cover rounded-t-lg"
            loading="lazy"
            onError={(e) => { 
              e.target.onerror = null; 
              e.target.src = `https://placehold.co/600x450/E5E7EB/6B7280?text=${encodeURIComponent(collection.title)}`; 
            }}
          />
        </div>
      </div>
      <div className="mt-3 sm:mt-4 px-3 sm:px-4 md:px-5 pb-3 sm:pb-4 md:pb-5 w-full flex flex-col justify-between flex-1">
        <div className="mb-3 sm:mb-4">
          <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 sm:mb-3 line-clamp-2">{collection.title}</h3>
          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed line-clamp-3">{collection.description}</p>
        </div>
        <Link to={collection.link} className="text-blue-600 text-sm sm:text-base font-bold no-underline hover:text-blue-800 hover:underline transition-colors duration-200 mt-auto block">
          View Collection →
        </Link>
      </div>
    </div>
  );
};

export const CuratedCollections = ({ title, description, collections }) => {
  const containerRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const checkScroll = () => {
    if (containerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 1);
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', checkScroll);
      checkScroll();
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', checkScroll);
      }
    };
  }, [collections]);

  const scroll = (direction) => {
    if (containerRef.current) {
      const isMobile = window.innerWidth < 640;
      const isTablet = window.innerWidth >= 640 && window.innerWidth < 768;
      const cardWidth = isMobile ? 250 : isTablet ? 280 : 300;
      const gap = isMobile ? 16 : isTablet ? 20 : 24;
      const scrollAmount = cardWidth + gap;

      if (direction === 'left') {
        containerRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        containerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="mt-20 sm:mt-28 md:mt-36 lg:mt-40 py-6 sm:py-8 md:py-10 text-center bg-gray-300 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 sm:mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-2 sm:mb-3">{title}</h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto leading-relaxed px-4">
            {description}
          </p>
        </div>

        <div className="flex items-center relative overflow-hidden">
          {showLeftArrow && (
            <button
              className="absolute left-1 sm:left-2 z-10 p-2 sm:p-3 bg-white rounded-full shadow-md transition-colors duration-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-75"
              onClick={() => scroll('left')}
              aria-label="Scroll Left"
            >
              <ChevronLeft className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-gray-700" />
            </button>
          )}

          <div
            className="flex overflow-x-scroll snap-x snap-mandatory scroll-smooth pb-3 sm:pb-4 no-scrollbar -mx-4 px-4 md:px-0"
            ref={containerRef}
            onScroll={checkScroll}
          >
            <div className="flex gap-4 sm:gap-5 md:gap-6 mt-6 sm:mt-8 flex-nowrap items-stretch">
              {collections.map((collection) => (
                <CollectionCard
                  key={collection.title}
                  collection={collection}
                  imageHeight="250px"
                />
              ))}
            </div>
          </div>

          {showRightArrow && (
            <button
              className="absolute right-1 sm:right-2 z-10 p-2 sm:p-3 bg-white rounded-full shadow-md transition-colors duration-200 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-75"
              onClick={() => scroll('right')}
              aria-label="Scroll Right"
            >
              <ChevronRight className="h-4 w-4 sm:h-5 sm:w-5 md:h-6 md:w-6 text-gray-700" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
